import * as $ from 'jquery';
import { LarchSys } from '../../utils/larchSys';


export function crossesBlock(larchSys: LarchSys) {

    let innerHeight = window.innerHeight;
    const handler = () => {
        requestAnimationFrame(() => {
            if (Math.abs(innerHeight - window.innerHeight) > 100) {
                innerHeight = window.innerHeight;
            }
            const vhFactor = window.pageYOffset / innerHeight;
            document.body.style.setProperty('--vh-factor', `${vhFactor}`);
        });
    };
    window.addEventListener('scroll', handler, false);
    handler();

}


//const Easing = {
//    // no easing, no acceleration
//    linear(t: number) { return t; },
//    // accelerating from zero velocity
//    easeInQuad(t: number) { return t * t; },
//    // decelerating to zero velocity
//    easeOutQuad(t: number) { return t * (2 - t); },
//    // acceleration until halfway, then deceleration
//    easeInOutQuad(t: number) { return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t; },
//    // accelerating from zero velocity
//    easeInCubic(t: number) { return t * t * t; },
//    // decelerating to zero velocity
//    easeOutCubic(t: number) { return (--t) * t * t + 1; },
//    // acceleration until halfway, then deceleration
//    easeInOutCubic(t: number) { return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1; },
//    // accelerating from zero velocity
//    easeInQuart(t: number) { return t * t * t * t; },
//    // decelerating to zero velocity
//    easeOutQuart(t: number) { return 1 - (--t) * t * t * t; },
//    // acceleration until halfway, then deceleration
//    easeInOutQuart(t: number) { return t < .5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t; },
//    // accelerating from zero velocity
//    easeInQuint(t: number) { return t * t * t * t * t; },
//    // decelerating to zero velocity
//    easeOutQuint(t: number) { return 1 + (--t) * t * t * t * t; },
//    // acceleration until halfway, then deceleration
//    easeInOutQuint(t: number) { return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t; }
//};


//function animate(duration: number, obj: {
//    from: () => number,
//    to: () => number,
//    timing: (n: number) => number,
//    draw: (n: number) => void,
//}) {
//    var start = new Date().getTime();

//    var fraction = 0, current = 0, running = true, finish = false;
//    requestAnimationFrame(function loop() {

//        current = lerp(obj.from(), obj.to(), obj.timing(fraction));

//        obj.draw(current);

//        const now = new Date().getTime();
//        const diff = (now - start) / duration;
//        fraction = diff;

//        if (finish) {
//            return;
//        }

//        if (running) {
//            fraction = Math.min(fraction, 1);
//            if (fraction === 1) {
//                finish = true;
//            }
//            requestAnimationFrame(loop);
//        }
//    });

//    return {
//        cancel() {
//            running = false;
//        }
//    };
//}

//function lerp(min: number, max: number, fraction: number) { return (max - min) * fraction + min; };


//let currentValue = 0;
//animate(10, {
//    from: () => currentValue,
//    to: () => window.pageYOffset / window.innerHeight,
//    timing: Easing.easeInCubic,
//    draw: output => {
//        currentValue = output;
//        document.body.style.setProperty('--vh-factor', `${output}`);
//    }
//});
